import React, { useEffect, useRef, useState } from "react";
import { pubCall } from "../utils/PubSub";
import Button from "../ui/Button";
import { InfoIcon } from "../utils/Icons";
import Status from "../ui/Status";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import { VALIDATE } from "../utils/Validators";
import Checkbox from "../ui/Checkbox";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { drawPicker } from "../popovers/Picker";
import { showError, showMessage } from "../ui/Message";
import Spin from "../ui/Spin";
import { getSaved, kbdEvent, save, ucfirst } from "../utils/Utils";
import Float from "../ui/Float";
import SelectBox from "../ui/SelectBox";

export default function TitleLinkSettings(props) {


    const { controller = "", callback = () => { }, route = "" } = props;

    const refs = useRef([]);
    const [index, setIndex] = useState("sort");
    const [loading, setLoading] = useState(false);

    const defaults = {
        limit: 100,
        sort: "I",
        scope: "B",
        default_search: "titlelink",
        default_new_tab: false,
    }


    const saved = getSaved("titlelink_settings");
    const title_link_settings = (saved) ? { ...defaults, ...saved } : defaults

    const [tabs, setTabs] = useState([
        { key: "limit", value: title_link_settings.limit },
        { key: "sort", value: title_link_settings.sort },
        { key: "scope", value: title_link_settings.scope },
        { key: "default_search", value: title_link_settings?.default_search || "titlelink" },
        { key: "default_new_tab", value: title_link_settings?.default_new_tab || false },
    ])

    const update = (_key, value) => {
        let _t = [...tabs];
        setTabs(_t.map(tab => tab.key === _key ? { ...tab, value: value } : tab)
        );
    }

    const getVal = (_key) => {
        return tabs.find(item => item.key === _key).value
    }

    const status = {
        limit: "Range between 1 and 100.",
        sort: <>Instock = your stock, then most popular</>,
        scope: <></>,
        default: <></>
    }


    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: true,
        controlled: true,
        autoselect: true,
        onChange: (e) => update(index, e)
    });


    const next = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };

    const setToDefaults = () => {
        setTabs([
            { key: "limit", value: defaults.limit },
            { key: "sort", value: defaults.sort },
            { key: "scope", value: defaults.scope },
            { key: "default_search", value: defaults.default_search },
            { key: "default_new_tab", value: defaults.default_new_tab },
        ])

    }

    const saveSettings = () => {

        if (!getVal("limit") || !getVal("sort") || !getVal("scope")) {
            showError({ error: "Invalid settings" })
            return;
        }

        const new_defaults = {
            limit: getVal("limit"),
            sort: getVal("sort"),
            scope: getVal("scope"),
            default_search: getVal("default_search"),
            default_new_tab: getVal("default_new_tab")
        }
        props.setDefaults(new_defaults)
        save("titlelink_settings", new_defaults);

        showMessage("Titlelink settings saved.")
        callback();
    }

    const onEnter = () => {
        switch (index) {
            case "default":
                setTabs(prevTabs => prevTabs.map(tab => tab.key === "default" ? { ...tab, value: !tab.value } : tab));
                break;
            case "sort":
                drawPicker({ controller: controller, value: getVal("sort"), ref: refs.current["sort"], route: route, callback: (e) => update("sort", e), offset: [0, -46], options: [{ value: "I", label: "In stock" }, { value: "F", label: "Forthcoming" }, { value: "R", label: "Rank" }, { value: "P", label: "Pubdate" }, { value: "T", label: "Title" }] })
                break;
            case "scope":
                drawPicker({ controller: controller, value: getVal("scope"), ref: refs.current["scope"], route: route, callback: (e) => update("scope", e), offset: [0, -26], options: [{ label: "Inactive", value: "I" }, { label: "Active", value: "A" }, { label: "Both", value: "B" }] })
                break;
        }
    }

    // Keyboard Events
    useEffect(() => {

        if (loading) {
            return;
        }

        if (refs?.current[index]) {
            refs.current[index].focus();
        }

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => next() },
            { key: KBD.ARROW_UP, action: (e) => prev() },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.ALT_S, action: (e) => { setToDefaults() } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            { key: KBD.PAGE_DOWN, action: (e) => { saveSettings() } },
            { key: KBD.ESCAPE, action: (e) => callback(false) },
            { key: KBD.ENTER, action: (e) => { onEnter() } }
        ];
        const cleanup = listen(controller, route, actions, (e) => {
            if (e.deltaY > 0) {
                next();
            } else {
                prev();
            }
        }, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.CTRL_C, KBD.CTRL_V, KBD.ALT_S], [], [KBD.CTRL_C, KBD.CTRL_V]);
        return cleanup;
    }, [index, update, loading]);






    return (

        <Spin style={{ "margin": "0px -10px" }} loading={loading} message={<Label>Searching...</Label>}>
            <div style={{ "width": "430px", "padding": "0px 10px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Maximum results</Label><Divider vertical />
                    <Input {...editProps("limit")} maxLength={3} number number_default={null} autoselect validator={VALIDATE.RANGE(1, 100)} placeholder="" width={50} edit value={getVal("limit")} />
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Sort results by:</Label><Divider vertical />
                    <Input doubleclick={KBD.ENTER} {...editProps("sort")} style={{ "textAlign": "center" }} maxLength={1} chars={["I", "F", "R", "P", "T", ""]} autoselect validator={VALIDATE.CHARS(["I", "F", "R", "P", "T"], false)} edit uppercase width={20} value={getVal("sort")} />
                    <Label>(Instock Forthcoming Rank Pubdate Title)</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Scope:</Label><Divider vertical />
                    <Input doubleclick={KBD.ENTER} {...editProps("scope")} style={{ "textAlign": "center" }} maxLength={1} chars={["I", "A", "B", ""]} autoselect validator={VALIDATE.CHARS(["I", "A", "B"], false)} edit uppercase width={20} value={getVal("scope")} />
                    <Label>(Active Inactive Both)</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Default Search:</Label><Divider vertical />
                    <SelectBox
                        width={140}
                        onClick={() => setIndex("default_search")}
                        value={getVal("default_search")}
                        options={[
                            { value: "titlelink", label: "Titlelink" },
                            { value: "local_inventory", label: "Local Inventory" },
                        ]}
                        {...editProps("default_search")}

                        onChange={(e) => {

                            update("default_search", e)
                        }}
                    />
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Open in new tab?</Label><Divider vertical />
                    <SelectBox
                        width={140}
                        onClick={() => setIndex("default_new_tab")}
                        value={getVal("default_new_tab")}
                        options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                        ]}
                        {...editProps("default_new_tab")}
                        onChange={(e) => {
                            update("default_new_tab", e)
                        }}
                    />
                </Space>

                <div className="shim" /><div className="shim" /> <div className="shim" /><div className="shim" /> <div className="shim" />
                <div style={{ "backgroundColor": "var(--console-bg)", "margin": "-10px -10px", "borderTop": "2px solid var(--border-secondary)", "padding": "10px" }}>
                    <Float>
                        <div>&nbsp;</div>
                        <div style={{ "padding": "0px 20px" }}>
                            <Space size={15}>
                                <Button onClick={() => setToDefaults()} styled>Reset to Defaults [Alt+S]</Button>
                                <Button onClick={() => kbdEvent(KBD.PAGE_DOWN)} styled>Save [PgDn]</Button>
                            </Space>
                        </div>
                    </Float>
                    <div className="shim" /><div className="shim" /><div className="shim" />
                    <Status><InfoIcon /> {status[index]}</Status>
                </div>
            </div>
        </Spin>
    )
}